const ENVIRONMENT = 'PRO';

export const environment = {
  production: true,
  defaultEnv: "PRO",
  apiTimeout: 500,
  appKey: "_appkeyDefault_",
  zupAppKey:"_zupAppKey_",
  cmsEndpoint: "_cmsEndpoint_",
  urlBffApi:"_urlBffApi_",
  landingUrl:"_landingUrl_",
  landingCMCUrl:"_landingCMCUrl_",
  urlIdentifyApi:"_urlIdentifyApi_",
  urlTracking:"_urlLogs_",
  isStaging: "_isStaging_",
  cmsHeaderStg:"_cmsHeaderStg_",
  showError: "_showerror_",
  secret:"_secret_",
  flag_hotjar: true,
  flag_anti_flicker: true,
  key_anti_flicker: "GTM-P2WFKSG",
  flag_optimize: true,
  flag_edit_name: '_flag_edit_name_',
  key_optimize: "_optimizeKey_",
  flag_google_analytics: true,
  key_google_analytics: "",
  id_google_tag_manager: "GTM-THV465P",
  bioElementsUrl:"_bio_elements_url_",
  termsElementUrl: "_term_elements_url_",
  cardsElementUrl: "_cards_elements_url_",
  offerPackage:{
    mainPath: '_offer_package_url_'
  },
  base:{
    url_hub: '_hubURL_',
    url_captcha_element:"_urlCaptchaElement_",
    url_overdraft_element:"_urlOfferOverdraft_",
    url_captcha: '_urlCaptcha_',
    url_crypto: '_urlCrypto_',
    url_apigee: '_urlApigee_',
    url_api_bff: '_urlBffApi_'
  },
  auth: {
    url_login: '_auth_url_login_',
    url_logout: '_auth_url_logout_',
    cliendId: '_auth_clientid_',
    apigee_app_key: '_auth_apigee_app_key_',
    zup_app_key: '_auth_zup_app_key_',
  },
  paths: {
    captcha: '_path_captcha_',
  },
  enableCaptcha:"_enableCaptcha_",
  path_captcha: '_pathCaptcha_',
  keys:{
    captcha:{
      visible:'_keysCaptchaVisible_',
      invisible:'_keysCaptchaInvisible_',
      sytemCode:'_keysSystemCode_',
      captchaKey: '_keysCaptchaKey_'
    }
  },
  dlb_crypt: '_dlb_crypt_',
  biometry:{
     keys:{
        projectNumber:"_projectNumber_",
        projectId:"_projectId_",
        mobileSdkAppId:"_mobileSdkAppId_",
        hostName:"_hostName_",
        hostInfo:"_hostInfo_",
        hostKey:"_hostKey_",
    },
    url_biometry_element:"_urlBiometryElement_",
    element_prefix:"_element_prefix_",
    useMfeBiometry: '_useMfeBiometry_'
  },
  document: {
    url_document_element:"_urlDocumentElement_",
  },
  clearSale:{
    appKey:'_clearSaleAppKey_',
    fcpMonitor:'_clearSaleFcpMonitor_',
    fpCheckUrl:'_clearSaleFpCheckUrl_',
    fpImgTag: '_clearSaleFpImgTag_',
    fpJs:'_clearSaleFpJs_'
  }
};
